<mat-form-field appearance="fill" class="" [hideRequiredMarker]="hideRequiredMarker"
                [class]="isControlInvalid ? 'scan-mat-form-field-invalid mat-form-field' : 'mat-form-field'">
  <mat-label class="d-flex align-items-center">
    <span class="mat-form-field-label">{{ translateService.instant(label) }}</span>
    @if (optional) {
      <span class="mat-form-field-label-optional">&nbsp;{{ 'common.optional' | translate }}</span>
    }
  </mat-label>

  @if (type === 'input') {
    <input [readonly]="readonly"
           [disabled]="readonly"
           matInput
           [value]="value"
           (input)="setValue(inputElement.value ? inputElement.value : '')"
           (focus)="isFocused = !isFocused"
           (blur)="isFocused = !isFocused"
           (keypress)="onKeyPress($event)"
           #inputElement>
  } @else if (type === 'textarea') {
    <textarea
      [readonly]="readonly"
      [disabled]="readonly"
      matInput
      [value]="value"
      (input)="setValue(textareaElement.value)"
      (focus)="isFocused = !isFocused"
      (blur)="isFocused = !isFocused"
      cdkTextareaAutosize
      [cdkAutosizeMinRows]="cdkAutosizeMinRows"
      [cdkAutosizeMaxRows]="cdkAutosizeMaxRows"
      #textareaElement
    ></textarea>
  }

  @if (isControlInvalid) {
    <mat-hint class="error-text" *ngIf="isControlInvalid">{{ errorMessage }}</mat-hint>
  }

  <div class="filled-form-field-suffix" matSuffix>
    @if (isSuffixIconVisible) {
      @if (icon === 'arrow') {
        @if (!isFocused) {
          <mat-icon class="contact-field-suffix">arrow_drop_down</mat-icon>
        } @else {
          <mat-icon class="contact-field-suffix">arrow_drop_up</mat-icon>
        }
      } @else if (icon === 'cached') {
        <mat-icon class="contact-field-suffix cursor-pointer" (click)="onGeneratePromoCodeClick()">{{icon}}</mat-icon>
      } @else if (icon === 'lock' || icon === 'help' || icon === 'percent') {
        <mat-icon class="contact-field-suffix">{{ icon }}_outline</mat-icon>
      }
    }
  </div>
</mat-form-field>
